import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vectraAi = defineConnector({
  identifier: "vectraAi",
  name: "Vectra AI",
  tagLine: "AI-driven threat detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ hostname }) =>
    hostname ? `https://${hostname.replace(/\./g, "\\.")}/.*` : "https://.*/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Vectra AI platform, go to **Manage → API Clients** and create a new API client. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Vectra instance hostname",
          required: true,
          placeholder: "vectra.example.com",
          target: { kind: "configuration", field: "hostname" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ hostname }) => `https://${hostname}/oauth2/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ hostname }) => `https://${hostname}/api/v3.3/health`,
  },
});
